import React, { useContext, useRef, useState } from "react";
const ClassEdit = (props) => {
  const pass = useRef("");

  const onSubmit = (e) => {};

  return (
    <div className='d-flex justify-content-center mt-5 mb-2 p-2'>
      <div
        className='card border-secondary w-100 mb-3'
        style={{ maxWidth: "30rem" }}
      >
        <div className='card-header fontcool'>Welcome Admin!</div>
        <div className='card-body'>
          <h4 className='card-title fontcool'>Enter password here</h4>
          <div className='form-group'>
            <input
              ref={pass}
              type='password'
              className='form-control simplefont'
              placeholder='Password'
            />
          </div>
          <input
            type='submit'
            className='btn btn-block btn-dark fontcool'
            value='Submit'
            onClick={onSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default ClassEdit;
